import { Navigate, useLocation } from 'react-router-dom';
import { LoginLogo } from '../components/LoginLogo';
import { LoginAlert } from '../features/Login/components';
import { NewPasswordForm, isFailedAuthResult } from '../features/Login';
import { FullScreenBackground, RightSpacer } from '../styles/LoginContainerStyle';

export function NewPassword() {
  const state: unknown = useLocation().state;

  if (!isFailedAuthResult(state)) {
    return <Navigate to="/login" />;
  }

  return (
    <>
      <LoginAlert />
      <FullScreenBackground>
        <LoginLogo />
        <RightSpacer>
          <img src="/images/icon_basic.png" alt="ProPlus" style={{ height: 40 }} />
          <NewPasswordForm session={state.session} email={state.email} />
        </RightSpacer>
      </FullScreenBackground>
    </>
  );
}
